import { Component, OnDestroy, OnInit } from '@angular/core';
import { AdvertiserDao } from '../../../core/services/dao/advertiserDao';
import { UserDao } from '../../../core/services/dao/userDao';
import { ActivatedRoute, Router } from '@angular/router';
import { Advertiser } from '../../../core/models/advertiser';

@Component({
  selector: 'app-pick-advertiser',
  templateUrl: './pick-advertiser.component.html',
  styleUrls: ['./pick-advertiser.component.scss']
})
export class PickAdvertiserComponent implements OnInit, OnDestroy {
  advertisers: Array<Advertiser> = [];
  filtered: Array<Advertiser> = [];

  constructor(private router: Router, private advertiserDao: AdvertiserDao, private userDao: UserDao) {}

  ngOnInit() {
    this.advertisers = this.userDao.getCurrentUser().advertisers;
    this.filter({ target: { value: '' } });
  }

  ngOnDestroy(): void {}

  pickAdvertiser(id) {
    /**
     * Hi there! this might look redundant, but it's actually a fix for an agency manager edge case
     * If you remove one of these the app will not navigate after a user picks an advertiser so please don't
     * remove it without adding more cases to the app.component.ts and the advertiser dao :)
     *
     * 2019-12-11: mads might have found a way to fix dis.
     */
    console.log('pick adv:', id);
    // this.advertiserDao.setCurrentAdvertiser(id);
    this.advertiserDao.setCurrentAdvertiser(id);
  }

  filter(event) {
    this.filtered = this.advertisers
      .filter(item => {
        let temp = item.name.toLowerCase();
        return temp.includes(event.target.value.toLowerCase());
      })
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  }
}
